var React = require('react');

function CoApplicant (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,"\n      .cls-1 {\n        fill: #fff;\n      }\n    ")),React.createElement("g",{"id":"two-men","transform":"translate(0 -102)","key":1},React.createElement("g",{"id":"people","transform":"translate(0 102)"},React.createElement("path",{"id":"Path_98","data-name":"Path 98","className":"cls-1","d":"M10.97,106.388a2.194,2.194,0,1,0-2.194-2.194A2.155,2.155,0,0,0,10.97,106.388Zm-5.851,0a2.194,2.194,0,1,0,0-4.388,2.194,2.194,0,1,0,0,4.388Zm0,1.463c-1.682,0-5.12.878-5.12,2.56v1.828H10.239V110.41C10.239,108.728,6.8,107.85,5.12,107.85Zm5.851,0a2.744,2.744,0,0,0-.731.073A3.016,3.016,0,0,1,11.7,110.41v1.828H16.09V110.41C16.09,108.728,12.653,107.85,10.97,107.85Z","transform":"translate(0 -102)"})))]);
}

CoApplicant.defaultProps = {"viewBox":"0 0 16.09 10.238"};

module.exports = CoApplicant;

CoApplicant.default = CoApplicant;
